import React from "react"
import SvgIcon from "@material-ui/core/SvgIcon"

const DoubleCheck = props => {
  return (
    <SvgIcon {...props}>
      <path
        className="a"
        d="M24.654,8.533,22.72,6.6a1.167,1.167,0,0,0-1.655,0L9.373,18.293,3.934,12.849a1.167,1.167,0,0,0-1.655,0L.341,14.787a1.173,1.173,0,0,0,0,1.66l8.2,8.207a1.167,1.167,0,0,0,1.655,0L24.649,10.193A1.177,1.177,0,0,0,24.654,8.533ZM8.821,13.708a.775.775,0,0,0,1.1,0L20.079,3.544a.784.784,0,0,0,0-1.1L17.872.229a.775.775,0,0,0-1.1,0l-7.4,7.4-2.7-2.71a.775.775,0,0,0-1.1,0L3.353,7.127a.784.784,0,0,0,0,1.1Z"
        transform="translate(0.004 0.002)"
      />
    </SvgIcon>
  )
}

export default DoubleCheck



// WEBPACK FOOTER //
// ./src/components/Icons/DoubleCheck/index.js